//import fetch from 'cross-fetch'

export const REQUEST_SUB_BANDS = 'REQUEST_SUB_BANDS'
export const RECEIVE_SUB_BANDS = 'RECEIVE_SUB_BANDS'
export const INVALIDATE_SUB_BANDS = 'INVALIDATE_SUB_BANDS'
export const REQUEST_COMMUNITY_NOTICES = 'REQUEST_COMMUNITY_NOTICES'
export const RECEIVE_COMMUNITY_NOTICES = 'RECEIVE_COMMUNITY_NOTICES'
export const INVALIDATE_COMMUNITY_NOTICES = 'INVALIDATE_COMMUNITY_NOTICES'
export const REQUEST_SUB_DISCOUNT_OUTLETS = 'REQUEST_SUB_DISCOUNT_OUTLETS'
export const RECEIVE_SUB_DISCOUNT_OUTLETS = 'RECEIVE_SUB_DISCOUNT_OUTLETS'
export const INVALIDATE_SUB_DISCOUNT_OUTLETS = 'INVALIDATE_SUB_DISCOUNT_OUTLETS'
export const REQUEST_TAXONOMIES = 'REQUEST_TAXONOMIES'
export const RECEIVE_TAXONOMIES = 'RECEIVE_TAXONOMIES'
export const INVALIDATE_TAXONOMIES = 'INVALIDATE_TAXONOMIES'

export function invalidateSubDiscountOutlets() {
  return {
    type: INVALIDATE_SUB_DISCOUNT_OUTLETS
  }
}

function requestSubDiscountOutlets() {
  return {
    type: REQUEST_SUB_DISCOUNT_OUTLETS
  }
}

function receiveSubDiscountOutlets(json) {
  return {
    type: RECEIVE_SUB_DISCOUNT_OUTLETS,
    subDiscountOutlets: json,
    receivedAt: Date.now()
  }
}

function fetchSubDiscountOutlets() {
  return dispatch => {
    dispatch(requestSubDiscountOutlets())
    return fetch('//jeff.4zzz.org.au/api/subdiscounts?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveSubDiscountOutlets(json)))
  }
}

function shouldFetchSubDiscountOutlets(state) {
  const subDiscountOutlets = state.subDiscountOutlets
  if (subDiscountOutlets.items.length === 0) {
    return true
  } else if (subDiscountOutlets.isFetching) {
    return false
  } else {
    return subDiscountOutlets.didInvalidate
  }
}

export function fetchSubDiscountOutletsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchSubDiscountOutlets(getState())) {
      return dispatch(fetchSubDiscountOutlets())
    }
  }
}

export function invalidateSubBands() {
  return {
    type: INVALIDATE_SUB_BANDS
  }
}

function requestSubBands() {
  return {
    type: REQUEST_SUB_BANDS
  }
}

function receiveSubBands(json) {
  return {
    type: RECEIVE_SUB_BANDS,
    subBands: json,
    receivedAt: Date.now()
  }
}

function fetchSubBands() {
  return dispatch => {
    dispatch(requestSubBands())
    return fetch('//jeff.4zzz.org.au/api/subbands/all/?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveSubBands(json)))
  }
}

function shouldFetchSubBands(state) {
  const subBands = state.subBands
  if (subBands.items.length === 0) {
    return true
  } else if (subBands.isFetching) {
    return false
  } else {
    return subBands.didInvalidate
  }
}

export function fetchSubBandsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchSubBands(getState())) {
      return dispatch(fetchSubBands())
    }
  }
}

export function invalidateCommunityNotices() {
  return {
    type: INVALIDATE_COMMUNITY_NOTICES
  }
}

function requestCommunityNotices() {
  return {
    type: REQUEST_COMMUNITY_NOTICES
  }
}

function receiveCommunityNotices(json) {
  return {
    type: RECEIVE_COMMUNITY_NOTICES,
    communityNotices: json,
    receivedAt: Date.now()
  }
}

function fetchCommunityNotices() {
  return dispatch => {
    dispatch(requestCommunityNotices())
    return fetch('//jeff.4zzz.org.au/api/community-notices?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveCommunityNotices(json)))
  }
}

function shouldFetchCommunityNotices(state) {
  const communityNotices = state.communityNotices
  if (communityNotices.items.length === 0) {
    return true
  } else if (communityNotices.isFetching) {
    return false
  } else {
    return communityNotices.didInvalidate
  }
}

export function fetchCommunityNoticesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchCommunityNotices(getState())) {
      return dispatch(fetchCommunityNotices())
    }
  }
}


export function invalidateTaxonomies() {
  return {
    type: INVALIDATE_TAXONOMIES
  }
}

function requestTaxonomies() {
  return {
    type: REQUEST_TAXONOMIES
  }
}

function receiveTaxonomies(json) {
  return {
    type: RECEIVE_TAXONOMIES,
    taxonomies: json,
    receivedAt: Date.now()
  }
}

function fetchTaxonomies() {
  return dispatch => {
    dispatch(requestTaxonomies())
    return fetch('//jeff.4zzz.org.au/api/tax?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveTaxonomies(json)))
  }
}

function shouldFetchTaxonomies(state) {
  const taxonomies = state.taxonomies
  if (taxonomies.items.length === 0) {
    return true
  } else if (taxonomies.isFetching) {
    return false
  } else {
    return taxonomies.didInvalidate
  }
}

export function fetchTaxonomiesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchTaxonomies(getState())) {
      return dispatch(fetchTaxonomies())
    }
  }
}
